import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MessageCircle, Phone, MapPin } from "lucide-react";
import { BRANCHES, waLink, telLink } from "@/lib/site-data";

export default function BranchChooser({ open, onOpenChange, title, description, message }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-testid="branch-chooser-dialog"
                className="sm:max-w-lg bg-cream border border-gold/40 rounded-sm p-0 overflow-hidden"
            >
                <div className="bg-maroon text-cream px-7 py-6 border-b border-gold/30">
                    <DialogHeader className="space-y-2 text-left">
                        <span className="eyebrow !text-gold-light">Aekkarag Thai Massage</span>
                        <DialogTitle className="font-serif text-3xl tracking-tight">
                            {title || "Choose a branch"}
                        </DialogTitle>
                        <DialogDescription className="text-cream/70 text-sm">
                            {description ||
                                "Tap a location below to message us directly on WhatsApp."}
                        </DialogDescription>
                    </DialogHeader>
                </div>

                <div className="p-6 space-y-4">
                    {BRANCHES.map((b) => (
                        <div
                            key={b.id}
                            className="border border-gold/30 hover:border-gold rounded-sm p-5 transition-all bg-beige/40"
                            data-testid={`branch-card-${b.id}`}
                        >
                            <div className="flex items-start justify-between gap-4 mb-4">
                                <div>
                                    <h4 className="font-serif text-2xl text-maroon leading-tight">
                                        {b.name}
                                    </h4>
                                    <p className="text-xs tracking-[0.18em] uppercase text-gold-dark mt-1">
                                        {b.label}
                                    </p>
                                </div>
                                <span className="shrink-0 text-[0.65rem] tracking-widest uppercase text-ink-muted">
                                    {b.hours.split("·")[0].trim()}
                                </span>
                            </div>
                            <div className="flex items-start gap-2 text-sm text-ink-soft mb-4">
                                <MapPin size={14} className="mt-1 text-gold-dark shrink-0" />
                                <span>{b.address}</span>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <a
                                    href={waLink(b.whatsapp, message)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`branch-${b.id}-whatsapp`}
                                    className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-[#25D366] text-white rounded-sm text-sm font-medium hover:bg-[#1ebf5a] transition"
                                    onClick={() => onOpenChange(false)}
                                >
                                    <MessageCircle size={16} />
                                    WhatsApp
                                </a>
                                <a
                                    href={telLink(b.phoneRaw)}
                                    data-testid={`branch-${b.id}-call`}
                                    className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-maroon text-cream rounded-sm text-sm font-medium hover:bg-maroon-deep transition"
                                    onClick={() => onOpenChange(false)}
                                >
                                    <Phone size={16} />
                                    {b.phone}
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
